import useMediaQuery from '@material-ui/core/useMediaQuery'
import { Room, Schedule, Today } from '@material-ui/icons'
import moment from 'moment'
import styled from 'styled-components'

import bg from '../../../../../assets/images/bg.jpg'

const Wrapper = styled.main`
  position: relative;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  min-height: ${props => props.height};
  padding: 30px;
  line-height: 1.1;
  color: var(--light-text);
  @media only screen and (min-width: 1440px) {
    min-height: 700px;
  }
  @media only screen and (max-width: 599px) {
    min-height: 240px;
    padding: 100px 20px 40px;
  }
`

const Background = styled.div`
  position: absolute;
  background-image: ${props => `url(${props.backgroundImage})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  z-index: -2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const DetailItem = styled.div`
  display: flex;
  margin-bottom: 14px;
  font-size: 18px;
  font-weight: 500;
  p {
    margin-top: 8px;
    max-width: 280px;
  }
  .MuiSvgIcon-root {
    font-size: 36px;
    color: var(--icon-color);
    margin-right: 28px;
  }
  @media only screen and (max-width: 960px) {
    font-size: 14px;
    p {
      margin-top: 4px;
    }
    .MuiSvgIcon-root {
      font-size: 24px;
    }
  }
  @media only screen and (max-width: 540px) {
    margin-bottom: 2px;
  }
`

const EventDetails = styled.div`
  width: max-content;
  background: var(--map-box-bg);
  border: 1px solid var(--border-color);
  padding: 50px 110px 30px 50px;
  color: var(--dark-text);
  line-height: 1;
  h3 {
    margin: 0 0 20px;
    font-size: 24px;
    font-weight: 700;
  }
  @media only screen and (max-width: 960px) {
    padding: 30px;
    h3 {
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 540px) {
    width: 100%;
    padding: 20px 50px 20px 30px;
    border: none;
  }
`

const EventInfo = styled.div`
  position: absolute;
  top: 20%;
  right: 8%;
  @media only screen and (max-width: 540px) {
    top: 10%;
    right: 20%;
  }
`

const OnlineDetails = ({ backgroundImage, date, time, allDayEvent }) => {
  const desktop = useMediaQuery('(min-width:540px)')

  return (
    <Wrapper id="key-details" height={desktop ? '500px' : '220px'}>
      <Background backgroundImage={backgroundImage} />
      <EventInfo>
        <EventDetails>
          <h3>Key Details</h3>
          {time && !allDayEvent && (
            <DetailItem>
              <Schedule />
              <p>{time}</p>
            </DetailItem>
          )}
          {date && (
            <DetailItem>
              <Today />
              <p>{moment(date).format('Do MMMM, YYYY')}</p>
            </DetailItem>
          )}
          <DetailItem>
            <Room />
            <p>Online Event</p>
          </DetailItem>
        </EventDetails>
      </EventInfo>
    </Wrapper>
  )
}

OnlineDetails.defaultProps = {
  backgroundImage: bg,
}

export default OnlineDetails
